import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {
  MessageManagerMessageTypeEnum,
  MessageManagerService,
  MessageManagerTypeEnum,
} from './message.manager.service';

@Injectable({
  providedIn: 'root',
})
export class GenericMessageService {
  constructor(private messageManager: MessageManagerService) {}

  public genericAlertMessageApiError(err: HttpErrorResponse) {
    this.customAlertMessageApiError(
      err?.error?.hasOwnProperty('detail') ? err.error.detail : 'GENERIC_ERROR'
    );
  }

  public customAlertMessageApiError(message: string) {
    this.messageManager.addMessage({
      type: MessageManagerTypeEnum.ALERT_MESSAGE,
      msgType: MessageManagerMessageTypeEnum.DANGER,
      title: 'ERROR_GENERATED',
      message,
      multiMessage: true,
    });
  }
}
